<template>
  <v-navigation-drawer v-if="breakpointName !== 'xs'" mobile-breakpoint="400" app>
    <v-col align="center">
      <logo-sidenav style="margin-top: 20px" />
      <p style="font-size: 14px" class="mt-2">
        {{ licenseeName }}
        {{ $t('message.company_honorific_title') }}
      </p>
      <v-btn text @click="logout">
        <span class="font-weight-bold text-decoration-underline">
          {{ $t('message.btn_logout') }}
        </span>
      </v-btn>
    </v-col>
    <v-list>
      <v-list-item-group v-for="(item, i) in items" :key="`item-${i}`">
        <v-list-item inactive :ripple="false" :class="{ 'mt-6': i !== 0 }">
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item>
        <v-divider />
        <div class="ml-6 my-3">
          <div v-for="(menu, i) in item.subItems" :key="`menu-${i}`">
            <v-list-item color="gray" :to="menu.path">
              <v-list-item-title
                ><p class="font-weight-bold ma-0">
                  {{ menu.name }}
                </p>
              </v-list-item-title>
            </v-list-item>
            <v-divider />
          </div>
        </div>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import logoSidenav from '../../assets/logoSidenav.svg'

export default {
  name: 'SideNav',
  components: { logoSidenav },
  data() {
    return {}
  },
  computed: {
    items() {
      let items = [
        {
          name: this.$t('message.usages'),
          subItems: [
            { name: this.$t('message.invoice'), path: '/invoice' },
          ]
        }
      ]
      if (this.licenseeType == "LICENSEE") {
        items.unshift({
          name: 'KitchenBASE Wiki',
          subItems: [
            { name: this.$t('message.notice'), path: '/wiki/f9b97452727c40e1a1a2fad4606a25fb' },
            { name: this.$t('message.manual'), path: '/wiki/dacee4ec78b2462781cf29ed71066b18' },
            { name: this.$t('message.guide'), path: '/wiki/5a9e7291cce44f90a35879391e2647c5' }
          ]
        },)
      }
      return items
    },
    licenseeName() {
      return this.$store.getters['licensees/licenseeName']
    },
    licenseeType() {
      return this.$store.getters['licensees/licenseeType']
    },
    breakpointName() {
      return this.$vuetify.breakpoint.name
    }
  },
  methods: {
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push('/login').catch(() => {})
          localStorage.removeItem('token')
        })
      this.resetAllStates()
    },
    navigatePage(path) {
      this.$router.push(path).catch(() => {})
    },
    resetAllStates() {
      this.$store.dispatch('common/clearState')
      this.$store.dispatch('contracts/clearState')
      this.$store.dispatch('invoices/clearState')
      this.$store.dispatch('licensees/clearState')
      this.$store.dispatch('platforms/clearState')
      this.$store.dispatch('restaurants/clearState')
      this.$store.dispatch('sales/clearState')
    }
  }
}
</script>
